module.exports = "<h1>Pracoviště</h1>\n<a href=\"#\" routerLink=\"/workplace\" class=\"float-right\">Nové</a>\n<table class=\"table table-bordered\">\n  <th>Název</th>\n  <th>Upravit</th>\n  <tr *ngFor=\"let workplace of workplaces\">\n    <td>{{workplace.name}}</td>\n    <td><a href=\"#\" routerLink=\"/workplace/{{workplace.id}}\">X</a></td>\n  </tr>\n</table>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/workplaces/workplaces.component.html
// module id = 470
// module chunks = 1